import React, {useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import general from "../../../utils/general";
import versionsService from "../../../services/versions-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import {EditorContent, EditorContext, useEditor} from "@tiptap/react";
import {StarterKit} from "@tiptap/starter-kit";
import {TextAlign} from "@tiptap/extension-text-align";
import {Underline} from "@tiptap/extension-underline";
import {Typography} from "@tiptap/extension-typography";
import Card from "../../../components/card";
import InputForm from "../../../components/input-form";
import InputDateTime from "../../../components/input-datetime";
import RichTextToolbar from "../../requests/components/RichTextToolbar";
import RichTextLinkExtension from "../../requests/components/RichTextLinkExtension";
import AttachesTable from "../../../components/attaches-table";
import {useQuery} from "@tanstack/react-query";
import {useNavigate, useParams} from "react-router-dom";
import Button from "../../../components/button";

const initialState = {
    version: "",
    date: "",
    content: "",
    attachs: [],
}
const VersionForm = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const [state, setState] = useState(initialState)
    const attachesRef = useRef();
    const editor = useEditor({
        immediatelyRender: false,
        editorProps: {
            attributes: {
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
            },
        },
        extensions: [
            StarterKit,
            TextAlign.configure({ types: ["heading", "paragraph"] }),
            Underline,
            Typography,
            RichTextLinkExtension
        ]
    });
    const providerValue = useMemo(() => ({ editor }), [editor])

    const handleInput = ({target: {name, value}}) => setState(prev => ({...prev, [name]: value}));
    const handleDateInput = (value, name) => setState(prev => ({...prev, [name]: value}));

    const {isFetching, refetch} = useQuery({
        queryFn: () => versionsService.getById(id).then(({data}) => {
            data.attachs = JSON.parse(data.attachs);
            editor.commands.setContent(data.content);
            setState(data)
            return[]
        }),
        queryKey: ['version', {id}],
        enabled: !!id,
    });

    const save = () => {
        const formData = new FormData();

        const form = {
            ...state,
            content: editor.getHTML(),
            date: general.formatDateToSave(state.date),
        }

        const attachesRow = [];
        attachesRef.current?.api.forEachNode((node) => {
            attachesRow.push(node.data);

            if (node.data?.file) formData.append("attaches[]", node.data.file);
        });

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        formData.append("attachs", JSON.stringify(attachesRow));

        if (!!id) formData.append('_method', 'PUT');

        const response = !!id ? versionsService.edit(formData, id) : versionsService.create(formData);

        response
            .then(({data}) => {
                toast.success("Salvo com sucesso.");
                id ? refetch() : navigate(`/versions/form/${data.id}`);
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
    }

    return (
        <TemplateDefault title={ (id ? "Edição" : "Cadastro") + " de versão"} isLoading={isFetching}>
            <Card>
                <div className="grid lg:grid-cols-12 gap-4">
                    {
                        id &&
                        <>
                            <InputForm value={state.id} id="id" name="id" label="ID"
                                       disabled={true}
                                       col="lg:col-span-2"/>
                        </>
                    }

                    <InputForm value={state.version} id="version" name="version" label="Versão"
                               onChange={handleInput}
                               col="lg:col-span-6"/>

                    <div className={"lg:col-span-" + (id ? "4" : "6")}>
                        <InputDateTime
                            id={"date"} name={"date"} label={"Data"}
                            selected={state.date}
                            onChange={(value) => handleDateInput(value, "date")}
                        />
                    </div>

                    <div className="col-span-12 lg:col-span-12">
                        <div>
                            <p>Conteúdo</p>
                            <EditorContext.Provider value={providerValue}>
                                <RichTextToolbar/>
                                <div className="content-wrapper version">
                                    <EditorContent editor={editor} className="editor-content"/>
                                </div>
                            </EditorContext.Provider>
                        </div>
                    </div>

                    <div className={"col-span-12"}>
                        <AttachesTable attaches={state.attachs} gridRef={attachesRef} isVersion submit={save}/>
                    </div>
                </div>
            </Card>
            <Card wrapperClass="mt-2">
                <div className="flex justify-end gap-3">
                    <Button onClick={() => navigate("/versions")} target="warning">
                        Cancelar
                    </Button>
                    <Button onClick={save} target="success">
                        Salvar
                    </Button>
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default VersionForm;
